import React, { useEffect } from "react";
import useUserStore from "../stores/store";
import useNotificationStore from "../stores/useNotificationStore";
import { useSocket } from "../hooks/useSocket";

function SocketAsPushNotification() {
  const { restaurantSlug } = useUserStore();
  const {setHasNewNotification} = useNotificationStore();
  const socket = useSocket(`${process.env.REACT_APP_IMAGE_BASE_URL}`);
  
  useEffect(() => {
    if (!socket || !restaurantSlug) {
      return;
    }

    // New Order Placed
    socket.on(`${restaurantSlug}-order-list-item-v2`, (data) => {
      console.log(`SocketAsPushNotification event: ${restaurantSlug}-order-list-item-v2`, {data});
      if (data.isNewOrder) {
        setHasNewNotification(true);
      }
    });

    // Order Update this time web admin do not receive any push
    // socket.on(`${restaurantSlug}-staff`, (data) => {
    //   setHasNewNotification(true);
    // });

  }, [socket, restaurantSlug]);

  return <></>;
}

export default SocketAsPushNotification;
